import React, { Fragment, useEffect, useState } from 'react';
import { useLocation } from "@remix-run/react";
import { styled } from 'styled-components';
import SvgChevron from '../../../../play-core/icons/Chevron';
import { Colors } from '../../../../play-core/styles/Colors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DebugWindow = () => {
  const location = useLocation();
  const [isVisible, setVisible] = useState(false);
  const [debugView, setDebugView] = useState(/*#__PURE__*/_jsx(Fragment, {}));
  useEffect(() => {
    if (isVisible) {
      import('./DebugView').then(({
        DebugView
      }) => {
        setDebugView(/*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(DebugView, {}), /*#__PURE__*/_jsx(StyledToggleButton, {
            onClick: () => setVisible(!isVisible),
            children: /*#__PURE__*/_jsx(SvgChevron, {
              orientation: isVisible ? 'up' : 'down'
            })
          })]
        }));
      });
    }
    // eslint-disable-next-line
  }, [isVisible]);
  useEffect(() => setVisible(location.hash === '#debug'), [location.hash]);
  useEffect(() => {
    document.onkeyup = event => {
      if (event.ctrlKey && event.key === 'd' && window.__PLAY__?.isRequestedViaCDN !== true) {
        setVisible(!isVisible);
      }
    };
    return () => {
      document.onkeyup = null;
    };
  }, [isVisible]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: isVisible && debugView
  });
};

// Not defined in Debug.styles.ts to make code splitting work
const StyledToggleButton = styled.button.withConfig({
  displayName: "DebugWindow__StyledToggleButton",
  componentId: "sc-1u5tx04-0"
})(["color:", ";position:fixed;top:0;right:0;font-size:16px;width:30px;height:30px;z-index:155;"], Colors.GREY_515151);